"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidResponseCardCms = void 0;
var PrepaidResponseCardCms = /** @class */ (function () {
    function PrepaidResponseCardCms() {
        this.orderTotalHeading = 'New estimated totals';
        this.orderTotalDeviceCostLabel = 'Device cost';
        this.orderTotalMonthlyCostLabel = 'Payment for monthly plan';
        this.orderTotalHeadsUpLabel = "Heads up: If you continue with AT&T PREPAID, the device and plan you\n    previously put in your cart will be removed. Also, you can always return to your cart to edit\n    your prepaid plan or device.";
        this.recommendedHeadingLabel = 'Recommended for you';
        this.recommendedSubHeadingLabel = "This device and plan most closely match\n    what you already have in your cart. Don\u2019t love these options?";
        this.prepaidDescriptionLabel = "Pay as you go with AT&T PREPAID\u2120.\n    It\u2019s a flexible option on the same great network.";
        this.prepaidFeaturesLabel = "4G LTE on the AT&T network|No annual contract|\n    No activation fees when you order online|Unlimited talk & text";
        this.browsePrepaidLinkLabel = 'Browse prepaid devices and plans instead';
        this.paymentPlanLabel = 'Payment for monthly plan';
        this.paymentPlanToolTipLabel = 'You’ll get a refill card to pay for the first month of your plan.';
        this.featuresLabel = 'See more features';
        this.legalStuffLabel = 'Read the legal stuff';
        this.priceDetailsLabel = 'See price details';
        this.wirelessPrepaidLegalLabel = "Service must be purchased and activated separately.";
    }
    return PrepaidResponseCardCms;
}());
exports.PrepaidResponseCardCms = PrepaidResponseCardCms;
//# sourceMappingURL=PrepaidResponseCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditResponseModal/PrepaidResponseCard/PrepaidResponseCard.cms.js
// module id = 954
// module chunks = 8